import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Link from '@mui/material/Link';
import ListItemButton from '@mui/material/ListItemButton';
import Collapse from '@mui/material/Collapse';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link as Linkreactrouter, Route, Routes, MemoryRouter, useLocation } from 'react-router';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/List": List, "@mui/material/Link": Link, "@mui/material/ListItemButton": ListItemButton, "@mui/material/Collapse": Collapse, "@mui/material/ListItemText": ListItemText, "@mui/material/Typography": Typography, "@mui/icons-material/ExpandLess": ExpandLess, "@mui/icons-material/ExpandMore": ExpandMore, "@mui/material/Breadcrumbs": Breadcrumbs, "react-router": { Link: Linkreactrouter, Route, Routes, MemoryRouter, useLocation } } } });
export default ClientProvider;
